import { useAppState } from 'hooks/useAppState';

export const usePasswordEditorState = () => {
  const { passwordEditorState } = useAppState();

  return passwordEditorState;
};
